import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";
import { useState, useEffect, FC, PropsWithChildren } from "react";
import { useAuthStatus } from "../../lib/stores/auth-store";
import { DecodedToken, refreshAccessToken } from "../../lib/axiosClient";

// const AuthContext = createContext<any>(undefined);

// export function useAuth() {
//   return useContext(AuthContext);
// }

// export const AuthProvider = ({ children }: PropsWithChildren) => {
//   const [loading, setLoading] = useState<boolean>(true);
//   const setIsLoggedIn = useAuthStatus((state) => state.setIsLoggedIn);

//   useEffect(() => {
//     function clearTokens() {
//       localStorage.removeItem("accessToken");
//       localStorage.removeItem("refreshToken");
//       setIsLoggedIn(false);
//       setLoading(false);
//     }

//     async function refresh() {
//       try {
//         setLoading(true);
//         await refreshAccessToken();
//         setIsLoggedIn(true);
//         setLoading(false);
//       } catch (error) {
//         clearTokens();
//       }
//     }

//     const at = localStorage.getItem("accessToken");
//     const rt = localStorage.getItem("refreshToken");
//     if (at && rt) {
//       const decodedToken: DecodedToken = jwtDecode(rt);
//       if (!decodedToken.roles.includes("SUPERADMIN")) {
//         clearTokens();
//         return;
//       }
//       if (dayjs.unix(decodedToken.exp) > dayjs()) {
//         refresh();
//       } else {
//         clearTokens();
//       }
//     } else {
//       clearTokens();
//     }

//     // Refresh token en arrière plan
//     const interval = setInterval(async () => {
//       try {
//         console.log("Refreshing token in background...");
//         await refreshAccessToken();
//       } catch (error) {
//         console.error("Error refreshing token in background", error);
//         clearTokens();
//       }
//     }, 600000);
//     return () => clearInterval(interval);
//   }, [setIsLoggedIn]);

//   const value = {
//     loading,
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {/* {!loading && children} */}
//       {children}
//     </AuthContext.Provider>
//   );
// };

const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const setIsLoggedIn = useAuthStatus((state) => state.setIsLoggedIn);

  useEffect(() => {
    function clearTokens() {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      setIsLoggedIn(false);
      setLoading(false);
    }

    async function refresh() {
      try {
        setLoading(true);
        await refreshAccessToken();
        setIsLoggedIn(true);
        setLoading(false);
      } catch (error) {
        clearTokens();
      }
    }

    const at = localStorage.getItem("accessToken");
    const rt = localStorage.getItem("refreshToken");
    if (at && rt) {
      const decodedToken: DecodedToken = jwtDecode(rt);

      if (dayjs.unix(decodedToken.exp) > dayjs()) {
        refresh();
      } else {
        clearTokens();
      }
    } else {
      clearTokens();
    }

    // Refresh token en arrière plan
    const interval = setInterval(async () => {
      try {
        console.log("Refreshing token in background...");
        await refreshAccessToken();
      } catch (error) {
        console.error("Error refreshing token in background", error);
        clearTokens();
      }
    }, 600000);
    return () => clearInterval(interval);
  }, [setIsLoggedIn]);

  return <> {!loading && children} </>;
};

export default AuthProvider;
